import { useCallback, useMemo, useRef } from "react"

import { useEditor } from "@craftjs/core"
import { get, set } from "lodash";

import createContextFactory from "@/utils/factory";

const useMerge = () => {
  const { actions: { history: { merge } } } = useEditor()

  const mapping = useMemo(() => ({
    /**
     *
     * @param {String[]} keys
     * @return {ReturnType<merge>}
     */

    get(keys) {
      const path = keys.join('.') || 'default'

      const func = get(this, path)
      if (func) {
        return func
      }

      set(this, path, merge())
      return this.get(keys)
    },
  }), [merge])

  return useCallback((...keys) => mapping.get(keys), [mapping])
}

const { Provider: HistoryProvider, useContext: useHistory } = createContextFactory(() => {
  const { actions: { history: { ignore } } } = useEditor()
  const ignoreRef = useRef(ignore)
  ignoreRef.current = ignore

  const merge = useMerge()

  return useMemo(() => ({
    merge,
    ignore: ignoreRef,
  }), [merge, ignoreRef])
})

export {
  HistoryProvider,
  useHistory,
}
